import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Typography, Tabs, Tab, Box, Chip } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface IProps {
    user: {
      email: string;
    };
  }

export interface IState {
    curation_stats: any;
    show: boolean;
    selectedBarcode: any;
    selectedProfiler: any;
    selectedRows: any[];
    toggleCleared: boolean;

    children?: React.ReactNode;
    tabIndex?: number;
    tabValue: string;
    customerLeadsCount: number;
    ticketsCount: number;
}

class PaymentsHeader extends React.Component<RouteComponentProps & WithTranslation & IProps, IState> {
    constructor(props: RouteComponentProps & WithTranslation & IProps) {
        super(props);
        let current_path = this.props.location.pathname.split('/');
        this.state = {
            curation_stats: {
                "barcodes_count": 0,
                "assigned_barcodes_count": 0,
                "inprogress_barcodes_count": 0,
                "curated_barcodes_count": 0
            },
            show: false,
            selectedBarcode: {},
            selectedProfiler: "",
            selectedRows: [],
            toggleCleared: false,
            // tabValue: current_path[2],
            tabValue: (current_path[2]) ? current_path[2] : 'payments-for-review',
            customerLeadsCount: 7,
            ticketsCount: 99
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleChange = (event: React.SyntheticEvent, newValue: number) => {
            this.props.history.push('/payments/' + newValue);
        };
        return (
            <div>
                <Typography variant="h4" className='page-title'>{t("Payments")}</Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={this.state.tabValue} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Payments For Review" value={"payments-for-review"} />
                        <Tab label="Bag Weights For Review" value={"bag-weights-for-review"} />
                        {
                            (["vijay@bintix.com", "kedarnath@bintix.com", "satheesh@bintix.com"].includes(this.props.user.email)) &&
                            <Tab label="Transactions Pending Approval" value={"transactions-pending-approval"} />
                        }
                        {/* <Tab label="Payments" /> */}
                    </Tabs>
                </Box>
            </div>
        )
    }
}

export default withRouter(withTranslation()(PaymentsHeader))